import { createRoot } from "react-dom/client"

import "./style.css"
import "./branding.css"

import * as Sentry from "@sentry/react"
import { ErrorFallback } from "./components/ErrorFallback"

import App from "./App"
import { LightswarmProvider } from "./providers/lightswarm"
import { SocketIOProvider } from "./providers/sockets"

const container: HTMLElement = document.getElementById("root")
const root = createRoot(container!)

const SERVER_IP = "127.0.0.1"
const SERVER_PORT = 8080

Sentry.init({
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://3dc5aebda1922dcd2a5c3c5550fbeccb@o4507406819065856.ingest.de.sentry.io/4511133302194257",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

root.render(
  <SocketIOProvider url={`http://${SERVER_IP}:${SERVER_PORT}`}>
    <LightswarmProvider>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => {
          // ensure error is passed as an Error object to satisfy the props
          const err = error instanceof Error ? error : new Error(String(error))
          return <ErrorFallback error={err} resetError={resetError} />
        }}
      >
        <App />
      </Sentry.ErrorBoundary>
    </LightswarmProvider>
  </SocketIOProvider>,
)
